import { PayloadProps, PutPayloadProps } from "src/models/service.models";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function adminJobCategory(data: PayloadProps) {
  return await apiCall.post(
    API_URL.CATEGORY_MANAGEMENT.JOB_CATEGORY.ADMIN_JOB_CATEGORY,
    data
  );
}

export async function adminViewSkillCategory(path: string) {
  return await apiCall.get(
    API_URL.CATEGORY_MANAGEMENT.JOB_CATEGORY.ADMIN_VIEW_SKILL_CATEGORY + path
  );
}

export async function deleteJobCategory(params: string) {
  return await apiCall.remove(
    API_URL.CATEGORY_MANAGEMENT.JOB_CATEGORY.DELETE_JOB_CATEGORY + params
  );
}

export async function getJobCategory() {
  return await apiCall.get(
    API_URL.CATEGORY_MANAGEMENT.JOB_CATEGORY.GET_JOB_CATEGORY
  );
}

export async function updateJobCategory(path: string, data: PutPayloadProps) {
  return await apiCall.put(
    API_URL.CATEGORY_MANAGEMENT.JOB_CATEGORY.EDIT_JOB_CATEGORY + path,
    data
  );
}
